import { useNavigate } from "react-router-dom";
import SeoHead from "@/components/feature/SeoHead";

const SITE_URL = import.meta.env.VITE_SITE_URL || "https://www.crownhongyunmall.com";

const privacyJsonLd = {
  "@context": "https://schema.org",
  "@type": "WebPage",
  "name": "隐私政策 | 皇冠鸿运商城",
  "description": "皇冠鸿运商城隐私政策，说明我们如何收集、使用、保护您的个人信息，以及您的隐私权利。",
  "url": `${SITE_URL}/privacy`,
  "inLanguage": "zh-CN",
  "dateModified": "2026-04-11",
  "isPartOf": { "@type": "WebSite", "name": "皇冠鸿运商城", "url": SITE_URL },
};

const sections = [
  {
    title: "一、信息收集",
    icon: "ri-database-2-line",
    content: [
      "我们在您使用皇冠鸿运商城服务时收集以下信息：",
      "**账户信息**：注册时提供的姓名、手机号码、电子邮箱地址。",
      "**交易信息**：您的订单记录、收货地址、支付方式（我们不存储完整银行卡号）。",
      "**设备信息**：设备型号、操作系统版本、IP 地址、浏览器类型，用于安全验证和服务优化。",
      "**使用数据**：页面浏览记录、搜索关键词、点击行为，用于改善购物体验和个性化推荐。",
      "**位置信息**：在您授权的情况下，获取大致地理位置，用于配送服务和本地化内容。",
    ],
  },
  {
    title: "二、信息使用",
    icon: "ri-settings-3-line",
    content: [
      "我们将收集的信息用于以下目的：",
      "**订单处理**：处理您的购买订单、安排配送、提供售后服务。",
      "**账户管理**：维护您的账户安全，验证身份，防止欺诈行为。",
      "**个性化服务**：根据您的浏览和购买历史，为您推荐可能感兴趣的商品。",
      "**客户服务**：回应您的咨询、投诉和建议，提供技术支持。",
      "**平台改善**：分析用户行为数据，优化平台功能和用户体验。",
      "**营销通知**：在您同意的情况下，向您发送促销活动、新品上架等通知（可随时退订）。",
    ],
  },
  {
    title: "三、信息共享",
    icon: "ri-share-line",
    content: [
      "我们不会出售您的个人信息。在以下情况下，我们可能与第三方共享您的信息：",
      "**物流合作伙伴**：为完成配送，我们将您的姓名、地址、联系方式提供给快递公司。",
      "**支付服务商**：为处理支付，我们与支付宝、微信支付等合规支付机构合作，仅传输必要的交易信息。",
      "**工厂卖家**：为处理订单，我们将必要的收货信息提供给相关工厂卖家。",
      "**法律要求**：当法律法规要求或政府机关依法要求时，我们将依法提供相关信息。",
      "**平台安全**：为防止欺诈、保护用户安全，我们可能与安全服务提供商共享必要信息。",
    ],
  },
  {
    title: "四、信息安全",
    icon: "ri-shield-check-line",
    content: [
      "我们采取多重技术和管理措施保护您的个人信息安全：",
      "**数据加密**：所有数据传输采用 SSL/TLS 加密，敏感信息（如密码）采用不可逆加密存储。",
      "**访问控制**：严格限制员工对用户数据的访问权限，仅授权人员可在必要时访问。",
      "**安全审计**：定期进行安全漏洞扫描和渗透测试，及时修复安全隐患。",
      "**数据备份**：定期备份数据，确保在意外情况下能够恢复服务。",
      "尽管我们采取了上述措施，互联网环境存在固有风险，我们无法保证绝对安全。如发生数据泄露，我们将在72小时内通知受影响用户。",
    ],
  },
  {
    title: "五、Cookie 使用",
    icon: "ri-settings-4-line",
    content: [
      "我们使用 Cookie 和类似技术来改善您的使用体验：",
      "**必要 Cookie**：维持您的登录状态、购物车内容，这些 Cookie 是平台正常运行所必需的。",
      "**分析 Cookie**：收集匿名的使用统计数据，帮助我们了解用户如何使用平台。",
      "**个性化 Cookie**：记住您的偏好设置（如语言、地区），提供个性化体验。",
      "**营销 Cookie**：在您同意的情况下，用于展示相关广告内容。",
      "您可以通过浏览器设置管理 Cookie 偏好，但禁用某些 Cookie 可能影响平台功能的正常使用。",
    ],
  },
  {
    title: "六、您的权利",
    icon: "ri-user-settings-line",
    content: [
      "根据适用法律，您对自己的个人信息享有以下权利：",
      "**查阅权**：您可以随时查阅我们持有的您的个人信息。",
      "**更正权**：如您的信息不准确，您有权要求更正。",
      "**删除权**：在特定情况下，您可以要求删除您的个人信息（注意：这可能影响您使用某些服务）。",
      "**可携带权**：您有权以结构化、常用格式获取您的个人数据副本。",
      "**撤回同意**：对于基于同意处理的信息，您可以随时撤回同意，不影响撤回前的处理合法性。",
      "**投诉权**：如您认为我们违反了隐私法规，您有权向相关监管机构投诉。",
      "如需行使上述权利，请通过本页底部的联系方式与我们联系，我们将在30天内回复。",
    ],
  },
  {
    title: "七、未成年人保护",
    icon: "ri-parent-line",
    content: [
      "皇冠鸿运商城的服务面向18周岁及以上的成年人。我们不会故意收集未成年人的个人信息。",
      "如果您是未成年人的父母或监护人，发现您的孩子向我们提供了个人信息，请立即联系我们，我们将及时删除相关信息。",
      "对于14周岁以下的儿童，我们要求其在父母或监护人的陪同下使用本平台，并需获得监护人的明确同意。",
    ],
  },
  {
    title: "八、政策更新",
    icon: "ri-refresh-line",
    content: [
      "我们可能会不时更新本隐私政策，以反映法律变化、业务调整或服务改进。",
      "重大变更时，我们将通过以下方式通知您：在平台首页显示醒目提示、向您的注册邮箱发送通知邮件。",
      "更新后的政策将在发布后30天生效。继续使用我们的服务即表示您接受更新后的政策。",
      "本政策最后更新日期：**2026年4月11日**。",
    ],
  },
];

export default function PrivacyPage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50" style={{ fontFamily: "'Noto Sans SC', sans-serif" }}>
      <SeoHead
        title="隐私政策 | 个人信息保护说明 | 皇冠鸿运商城"
        description="皇冠鸿运商城隐私政策，详细说明我们如何收集、使用、保护您的个人信息，以及您依法享有的隐私权利，包括查阅权、更正权、删除权等。"
        keywords="隐私政策,个人信息保护,数据安全,皇冠鸿运商城"
        canonical="/privacy"
        jsonLd={privacyJsonLd}
      />

      {/* Header */}
      <div className="bg-gradient-to-r from-red-600 to-red-700 text-white">
        <div className="max-w-4xl mx-auto px-4 py-10">
          <button
            onClick={() => navigate("/")}
            className="flex items-center gap-2 text-red-200 hover:text-white text-sm mb-6 cursor-pointer transition-colors"
          >
            <i className="ri-arrow-left-line"></i> 返回首页
          </button>
          <div className="flex items-center gap-4 mb-3">
            <div className="w-12 h-12 flex items-center justify-center bg-white/20 rounded-xl">
              <i className="ri-shield-user-line text-2xl"></i>
            </div>
            <div>
              <h1 className="text-2xl font-bold" style={{ fontFamily: "'Noto Serif SC', serif" }}>
                隐私政策
              </h1>
              <p className="text-red-200 text-sm">Privacy Policy</p>
            </div>
          </div>
          <p className="text-red-100 text-sm leading-relaxed max-w-2xl">
            皇冠鸿运商城（以下简称"我们"或"平台"）非常重视您的隐私保护。本政策说明我们如何收集、使用、存储和保护您的个人信息，以及您依法享有的权利。
          </p>
          <div className="flex items-center gap-4 mt-4 flex-wrap">
            <span className="flex items-center gap-1.5 text-red-200 text-xs">
              <i className="ri-calendar-line"></i>
              最后更新：2026年4月11日
            </span>
            <span className="flex items-center gap-1.5 text-red-200 text-xs">
              <i className="ri-file-text-line"></i>
              适用范围：www.crownhongyunmall.com 及 Crowntalk 应用
            </span>
          </div>
        </div>
      </div>

      {/* Quick nav */}
      <div className="bg-white border-b border-gray-100 sticky top-0 z-30">
        <div className="max-w-4xl mx-auto px-4 py-3 overflow-x-auto">
          <div className="flex items-center gap-2 min-w-max">
            <span className="text-gray-400 text-xs whitespace-nowrap">快速导航：</span>
            {sections.map((s, i) => (
              <a
                key={i}
                href={`#section-${i}`}
                className="text-xs text-gray-500 hover:text-red-500 whitespace-nowrap px-2 py-1 rounded hover:bg-red-50 transition-colors cursor-pointer"
              >
                {s.title.split("、")[1]}
              </a>
            ))}
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-4xl mx-auto px-4 py-10">
        {/* Intro box */}
        <div className="bg-red-50 border border-red-100 rounded-2xl p-5 mb-8 flex items-start gap-3">
          <div className="w-10 h-10 flex items-center justify-center bg-red-100 rounded-xl flex-shrink-0">
            <i className="ri-information-line text-red-500 text-lg"></i>
          </div>
          <div>
            <p className="text-red-800 font-semibold text-sm mb-1">重要提示</p>
            <p className="text-red-700 text-sm leading-relaxed">
              请在使用皇冠鸿运商城服务前仔细阅读本隐私政策。使用我们的服务即表示您同意本政策的条款。
              如您不同意，请停止使用我们的服务。如有疑问，请通过
              <strong> privacy@crownhongyunmall.com </strong>
              联系我们的隐私保护团队。
            </p>
          </div>
        </div>

        {/* Sections */}
        <div className="space-y-6">
          {sections.map((section, idx) => (
            <div
              key={idx}
              id={`section-${idx}`}
              className="bg-white rounded-2xl p-6 border border-gray-100"
            >
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 flex items-center justify-center bg-red-50 rounded-xl flex-shrink-0">
                  <i className={`${section.icon} text-red-500 text-lg`}></i>
                </div>
                <h2 className="text-gray-900 font-bold text-base" style={{ fontFamily: "'Noto Serif SC', serif" }}>
                  {section.title}
                </h2>
              </div>
              <div className="space-y-2.5 pl-1">
                {section.content.map((line, li) => {
                  const isBold = line.startsWith("**") && line.includes("**：");
                  if (isBold) {
                    const [boldPart, ...rest] = line.split("**：");
                    const label = boldPart.replace(/\*\*/g, "");
                    return (
                      <div key={li} className="flex items-start gap-2">
                        <div className="w-1.5 h-1.5 bg-red-400 rounded-full mt-2 flex-shrink-0"></div>
                        <p className="text-gray-600 text-sm leading-relaxed">
                          <strong className="text-gray-800">{label}：</strong>
                          {rest.join("**：")}
                        </p>
                      </div>
                    );
                  }
                  if (line.startsWith("**") && line.endsWith("**")) {
                    return (
                      <p key={li} className="text-gray-700 font-semibold text-sm">
                        {line.replace(/\*\*/g, "")}
                      </p>
                    );
                  }
                  return (
                    <p key={li} className="text-gray-600 text-sm leading-relaxed">
                      {line.replace(/\*\*/g, "")}
                    </p>
                  );
                })}
              </div>
            </div>
          ))}
        </div>

        {/* Contact */}
        <div className="mt-8 bg-gradient-to-r from-red-500 to-red-600 rounded-2xl p-6 text-white">
          <div className="flex items-center gap-3 mb-4">
            <div className="w-10 h-10 flex items-center justify-center bg-white/20 rounded-xl">
              <i className="ri-mail-line text-xl"></i>
            </div>
            <h3 className="font-bold text-lg" style={{ fontFamily: "'Noto Serif SC', serif" }}>
              联系我们的隐私保护团队
            </h3>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
            {[
              { icon: "ri-mail-line", label: "隐私邮箱", value: "privacy@crownhongyunmall.com" },
              { icon: "ri-global-line", label: "官方网站", value: "www.crownhongyunmall.com" },
              { icon: "ri-map-pin-line", label: "注册地址", value: "广东省广州市" },
            ].map((item) => (
              <div key={item.label} className="bg-white/15 rounded-xl p-3">
                <div className="flex items-center gap-2 mb-1">
                  <i className={`${item.icon} text-white/70 text-sm`}></i>
                  <span className="text-white/70 text-xs">{item.label}</span>
                </div>
                <p className="text-white font-medium text-sm">{item.value}</p>
              </div>
            ))}
          </div>
          <p className="text-red-100 text-xs mt-4">
            我们承诺在收到您的请求后30天内给予回复。如涉及复杂情况，我们将在60天内处理完毕并告知您进展。
          </p>
        </div>

        {/* Related links */}
        <div className="mt-6 flex flex-wrap gap-3 justify-center">
          <a href="/terms" className="flex items-center gap-1.5 text-gray-500 hover:text-red-500 text-sm cursor-pointer transition-colors">
            <i className="ri-file-text-line"></i> 用户协议
          </a>
          <span className="text-gray-300">|</span>
          <a href="/" className="flex items-center gap-1.5 text-gray-500 hover:text-red-500 text-sm cursor-pointer transition-colors">
            <i className="ri-home-line"></i> 返回首页
          </a>
          <span className="text-gray-300">|</span>
          <a href="/products" className="flex items-center gap-1.5 text-gray-500 hover:text-red-500 text-sm cursor-pointer transition-colors">
            <i className="ri-shopping-bag-line"></i> 商品列表
          </a>
        </div>
      </div>
    </div>
  );
}